import 'twin.macro'

import FacebookIcon from 'assets/icons/FacebookIcon'
import FFLogo from 'assets/icons/FreedomLogo'
import InstagramIcon from 'assets/icons/InstagramIcon'
import PhoneIcon from 'assets/icons/PhoneIcon'
import TikTokIcon from 'assets/icons/TikTokIcon'
import WhatsappIcon from 'assets/icons/WhatsApp'
import ContactItem from 'components/UI/contact/contacat-item'
import { ThemeContext } from 'contexts/theme-context'
import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'
function MobileFooter() {
  const { t } = useTranslation()
  const { theme } = useContext(ThemeContext)

  return (
    <>
      <div
        css={theme === 'dark' ? tw`border-[#454545]` : tw`border-[#DBDBDB]`}
        tw='w-full border border-l-0 border-r-0 py-6 mt-10'
      >
        <div tw='max-w-landing mx-auto flex justify-between px-2'>
          <div tw='text-green flex gap-10'>
            {/*<ContactItem*/}
            {/*  link='https://wa.me/77760595595'*/}
            {/*  placement={'footer'}*/}
            {/*  icon={<WhatsappIcon />}*/}
            {/*  label='+7 776 1 595 595'*/}
            {/*  caption={'WHATSAPP'}*/}
            {/*/>*/}
            <ContactItem
              link='tel:595'
              icon={<PhoneIcon />}
              placement={'footer'}
              label='595'
              caption={`${t('free_call', { ns: 'footer' })}`}
            />
          </div>
        </div>
      </div>
      <div tw='max-w-landing mx-auto flex justify-between py-6 h-auto px-2'>
        <div>
          <div tw='flex items-center mb-5 justify-between'>
            <FFLogo />

            <div tw='flex gap-4'>
              <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full text-green'>
                <a href={'/'}>{<InstagramIcon />}</a>
              </div>
              <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full text-green'>
                <a href={'/'}>{<FacebookIcon />}</a>
              </div>
              <div tw='sm:w-[32px] sm:h-[32px] h-[28px] w-[28px] flex items-center justify-center bg-secondary rounded-full text-green'>
                <a href={'/'}>{<TikTokIcon />}</a>
              </div>
            </div>
          </div>
          <div tw='flex flex-col items-end text-right'>
            <p tw='text-[10px] uppercase text-secondary'>
              <Trans>{t('address', { ns: 'footer' })}</Trans>
            </p>
            <p tw='text-[10px] uppercase text-secondary'>
              <Trans components={{ br: <br /> }}>{t('license', { ns: 'footer' })}</Trans>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default MobileFooter
